import { AuthTabs } from '@wellesley/auth'

export const AuthTabsPage = () => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <AuthTabs />
    </div>
  )
}
